const sensorCacheKey = "sensor-run-state-cache";
export const SetSensorStates = (sensorId: number, enabled: boolean) => {
  let store: any = localStorage.getItem(sensorCacheKey);
  if (store) {
    store = JSON.parse(store);
  } else {
    store = {};
  }

  store[sensorId.toString()] = enabled;
  localStorage.setItem(sensorCacheKey, JSON.stringify(store));
};

export const GetSensorStates = (sensorId: number) => {
  let store: any = localStorage.getItem(sensorCacheKey);
  if (store) {
    store = JSON.parse(store);
  } else {
    store = {};
  }
  return store[sensorId.toString()] ? store[sensorId.toString()] : false;
};

export const RemoveSensorState = (sensorId: number) => {
  let store: any = localStorage.getItem(sensorCacheKey);
  if (store) {
    store = JSON.parse(store);
  } else {
    store = {};
  }
  delete store[sensorId.toString()];
  localStorage.setItem(sensorCacheKey, JSON.stringify(store));
};
